import { mount } from 'svelte'
import './app.css'
import Login from './User/Auth/Login.svelte'

const app = mount(Login, {
  target: document.getElementById('app')!,
})

export default app
